import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { UserContextType, useAuth } from "./auth";

interface ProtectedRouteProps {
  children: ReactNode;
  // Any one of these roles grants access. Defaults to Admin only.
  roles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  roles = ["Admin"],
}) => {
  const { IsAuthenticated, HasRole } = React.useContext<UserContextType>(useAuth);

  if (!IsAuthenticated || !IsAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (!HasRole || !roles.some((role) => HasRole(role))) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
